import React from "react";
import PropTypes from "prop-types";

import DataTable from "@components/DataTableV2/DataTable";

import ActivityLogDetails from "@pages/admin/activityLogs/Details";

import { useActivityLogList } from "./ActivityLogList.hooks";

const ActivityLogList = ({ activityLogData }) => {
  const { config, selectedActivityLog, handleCloseActivityLogDetails } =
    useActivityLogList(activityLogData);

  return (
    <>
      {selectedActivityLog && (
        <ActivityLogDetails
          data={selectedActivityLog}
          handleClose={handleCloseActivityLogDetails}
        />
      )}

      <DataTable config={config} />
    </>
  );
};

ActivityLogList.propTypes = {
  activityLogData: PropTypes.array,
};

export default ActivityLogList;
